module.exports = __webpack_public_path__ + "static/media/Snowmobile.e2063766.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Snowmobile.png
// module id = 3035
// module chunks = 0